import { initMercadoPago } from '@mercadopago/sdk-react'
import { MP_PUBLIC } from 'constants/envs'
import Routes from 'routes'

initMercadoPago(MP_PUBLIC)

const App = () => (
  <Routes />
)

export default App;
